import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { compose } from 'recompose';
import { useRouteMatch } from 'react-router-dom';

import { isNewClient } from '../../utils/statusFilter';
import { getClientPagePath } from '../../../utils/routes';
import ChatButton from '../ChatButton';
import Avatar from '../../../components/Avatar';
import ClientQuickInfoButton from '../ClientQuickInfoButton';
import AddClientTaskButton from '../AddClientTaskButton';
import ClientPostPaymentFormButton from '../ClientPostPaymentFormButton';
import AvatarSizeType from '../../../components/Avatar/AvatarSizes';

import {
  Container,
  ActionButtonContainer,
  StyledLink,
  TextContainer,
  SubTitle,
  StyledChatButtonContainer,
  StyledSecondaryProfileActionContainer,
  SubLine,
} from './styles';

const UserProfileCard = ({
  clientId,
  avatarSize,
  dataRow,
  showButtonsOnHover,
  subTitle,
  className,
  subLine,
  hideActions,
  hasPostPaymentFormAnswer,
}) => {
  const {
    params: {
      userId: coachId,
    },
  } = useRouteMatch();

  const showNewBadge = useMemo(() => isNewClient(dataRow), [dataRow]);

  return (
    <Container className={className}>
      <Avatar
        image={dataRow?.userAvatar}
        name={dataRow.userName}
        avatarSize={avatarSize}
        showNewBadge={showNewBadge}
        showAIFriendBadge={!!dataRow.isAIFriendEnabled}
      />
      <TextContainer>
        <StyledLink to={getClientPagePath(coachId, clientId)}>
          {dataRow.userName}
        </StyledLink>
        {!!subTitle && (
          <SubTitle>{subTitle}</SubTitle>
        )}
        {
          subLine && (
          <SubLine>
            {subLine}
          </SubLine>
          )
        }
      </TextContainer>
      {!hideActions && (
        <ActionButtonContainer $showOnHover={showButtonsOnHover}>
          <StyledChatButtonContainer>
            <ChatButton
              userId={clientId}
              popperPlacement="right-start"
              iconVariant="secondary"
              iconButton
            />
          </StyledChatButtonContainer>
          <StyledSecondaryProfileActionContainer>
            <ClientQuickInfoButton userId={clientId} iconButton />
          </StyledSecondaryProfileActionContainer>
          <StyledSecondaryProfileActionContainer>
            <AddClientTaskButton clientId={clientId} coachId={coachId} />
          </StyledSecondaryProfileActionContainer>
          {hasPostPaymentFormAnswer && (
            <StyledSecondaryProfileActionContainer>
              <ClientPostPaymentFormButton userId={clientId} />
            </StyledSecondaryProfileActionContainer>
          )}
        </ActionButtonContainer>
      )}
    </Container>
  );
};

UserProfileCard.propTypes = {
  clientId: PropTypes.string.isRequired,
  avatarSize: PropTypes.oneOf(AvatarSizeType),
  dataRow: PropTypes.object.isRequired,
  showButtonsOnHover: PropTypes.bool,
  subTitle: PropTypes.string,
  className: PropTypes.string,
  subLine: PropTypes.string,
  hideActions: PropTypes.bool,
  hasPostPaymentFormAnswer: PropTypes.bool,
};

UserProfileCard.defaultProps = {
  avatarSize: AvatarSizeType.MEDIUM,
  showButtonsOnHover: false,
  subTitle: '',
  className: '',
  subLine: '',
  hideActions: false,
  hasPostPaymentFormAnswer: false,
};

export default compose(
  observer,
)(UserProfileCard);
